exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert{margin-bottom:0}som-tab{overflow-x:scroll;overflow-y:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-db2c39da","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?outputStyle=expanded!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/routes/Alerts.vue
// module id = m3T+
// module chunks = 1